import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import { MENU_ENUM } from 'app/main/role/constants';
import i18next from 'i18next';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'role', en);

const CreateRoleConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Create Role',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.ROLE,
  permission: PERMISSION.CREATE,
  routes: [
    {
      path: '/role/create',
      component: React.lazy(() => import('./CreateRole')),
    },
  ],
};

export default CreateRoleConfig;
